// MOISSANITE_V3_1_HEADER
// MOISSANITE_V2_3_REBRAND
import { useEffect, useState } from 'react';
import { navigate } from '@/hooks/useRoute';
import { MEDIA } from '@/data/site';
import { useStore } from '@/context/StoreContext';
import './HeaderEditorialMegaV724.css';
import './HeaderMielleyPowerV1.css';
import './HeaderMegaOptionA.css';

type MegaMenu = 'rings' | 'jewelry' | null;

export function Header(){
 const {cart,wishlist,cms}=useStore();
 const [menu,setMenu]=useState(false);
 const [search,setSearch]=useState(false);
 const [mega,setMega]=useState<MegaMenu>(null);
 const [q,setQ]=useState('');

 const go=(path:string)=>{
  setMenu(false);
  setSearch(false);
  setMega(null);
  navigate(path);
 };

 const category=(key:string,fallback:string)=>cms.categories[key]?.label||fallback;
 const announcements=cms.site.announcement?.length
  ?cms.site.announcement
  :['משלוח חינם ומבוטח','30 ימי החזרה והחלפה','עד 12 תשלומים ללא ריבית','ייעוץ אישי ללא עלות'];

 useEffect(()=>{
  const onKey=(e:KeyboardEvent)=>{
   if(e.key==='Escape'){
    setMega(null);
    setMenu(false);
    setSearch(false);
   }
  };
  window.addEventListener('keydown',onKey);
  return()=>window.removeEventListener('keydown',onKey);
 },[]);

 const navLink=(label:string,path:string,className='')=>(
  <a
   className={`v724-nav-link ${className}`.trim()}
   href={path}
   onMouseEnter={()=>setMega(null)}
   onFocus={()=>setMega(null)}
   onClick={e=>{e.preventDefault();go(path)}}
  >{label}</a>
 );

 const trigger=(label:string,type:Exclude<MegaMenu,null>)=>(
  <button
   className={`v724-mega-trigger${mega===type?' active':''}`}
   aria-expanded={mega===type}
   aria-haspopup="true"
   onMouseEnter={()=>setMega(type)}
   onFocus={()=>setMega(type)}
   onClick={()=>setMega(current=>current===type?null:type)}
  >
   {label}<span aria-hidden="true">⌄</span>
  </button>
 );

 const card=(args:{
  title:string;
  subtitle:string;
  path:string;
  image:string;
  alt:string;
  mediaClassName?:string;
 })=>(
  <a className="v724-card" href={args.path} onClick={e=>{e.preventDefault();go(args.path)}}>
   <div className={`v724-card-media ${args.mediaClassName||""}`.trim()}><img src={args.image} alt={args.alt}/></div>
   <div className="v724-card-copy">
    <h3>{args.title}</h3>
    <p>{args.subtitle}</p>
    <span>לצפייה ←</span>
   </div>
  </a>
 );

 return <>

 <style>{`
  .site-header .header-main {
  position: relative !important;
  min-height: 120px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.mielley-final-logo {
  position: absolute !important;

  left: 50% !important;
  top: 44% !important;

  transform: translate(-50%, -50%) !important;

  width: 480px !important;
  max-width: 46vw !important;

  margin: 0 !important;
  padding: 0 !important;

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  background: transparent !important;
  background-image: none !important;
  border: 0 !important;
  box-shadow: none !important;

  z-index: 10 !important;
}

  .mielley-final-logo::before,
  .mielley-final-logo::after {
    content: none !important;
    display: none !important;
  }

  .mielley-final-logo img {
  display: block !important;
  width: 100% !important;
  height: auto !important;
  max-height: 90px !important;

  margin: 0 !important;
  padding: 0 !important;

  object-fit: contain !important;
  background: transparent !important;
  box-shadow: none !important;
}

.site-header .header-main {
  min-height: 120px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
`}</style>
  <div className="announcement">
   <div className="mielley-ticker-wrap" aria-label="הטבות ועדכונים">
  <div className="mielley-ticker-track">
    {[0,1].map(copy=>(
      <div className="mielley-ticker-group" key={copy} aria-hidden={copy===1 ? true : undefined}>
        {[
          'משלוח חינם ומבוטח',
          '30 ימי החזרה והחלפה',
          'עד 12 תשלומים ללא ריבית',
          'ייעוץ אישי ללא עלות',
          '10% הנחה לקנייה הראשונה ללקוחות חדשים'
        ].map((text,i)=>(
          <span className="mielley-ticker-item" key={`${copy}-${i}`}>
            {text==='ייעוץ אישי ללא עלות'
              ? <a href="/appointments" onClick={e=>{e.preventDefault();go('/appointments')}}>{text}</a>
              : text}
            <span className="mielley-ticker-separator" aria-hidden="true"/>
          </span>
        ))}
      </div>
    ))}
  </div>
</div>
  </div>

  <header className="site-header v724-site-header">
   <div className="container header-main">
   <div className="header-tools">
  <button
    className="icon-btn mobile-menu-btn"
    onClick={()=>setMenu(true)}
    aria-label="תפריט"
  >
    ☰
  </button>
</div>

   <a
  className="mielley-final-logo"
  href="/"
  onClick={e=>{e.preventDefault();go('/')}}
>
  <img
    src="/assets/mielley-brand-logo.png"
    alt="MIELLEY — LOOK EXPENSIVE. THINK SMART."
  />
</a>

    <div className="header-tools end mielley-clean-tools">
     <a className="icon-btn mielley-tool-btn mielley-account-btn" href="/account" onClick={e=>{e.preventDefault();go('/account')}} aria-label="אזור אישי">
      <svg viewBox="0 0 24 24" aria-hidden="true">
       <circle cx="12" cy="7.4" r="4.1"/>
       <path d="M4.7 20c.6-4.1 3.4-6.3 7.3-6.3s6.7 2.2 7.3 6.3"/>
      </svg>
     </a>
     <button className="icon-btn mielley-tool-btn header-search-btn" onClick={()=>setSearch(true)} aria-label="חיפוש" type="button">
      <svg viewBox="0 0 24 24" aria-hidden="true">
       <circle cx="10.5" cy="10.5" r="6.3"/>
       <path d="M15.2 15.2 20 20"/>
      </svg>
     </button>
     <a className="icon-btn mielley-tool-btn mielley-wishlist-btn" href="/wishlist" onClick={e=>{e.preventDefault();go('/wishlist')}} aria-label="מועדפים">
      <svg viewBox="0 0 24 24" aria-hidden="true">
       <path d="M20.2 5.8c-2.2-2.2-5.7-1.7-8.2 1-2.5-2.7-6-3.2-8.2-1-2.6 2.6-1.7 6.4.8 8.9L12 21l7.4-6.3c2.5-2.5 3.4-6.3.8-8.9Z"/>
      </svg>
      {wishlist.length>0&&<b>{wishlist.length}</b>}
     </a>
     <a className="icon-btn mielley-tool-btn mielley-cart-btn" href="/cart" onClick={e=>{e.preventDefault();go('/cart')}} aria-label="סל קניות">
      <svg viewBox="0 0 24 24" aria-hidden="true">
       <path d="M5.6 8.2h12.8l-.8 11.3H6.4L5.6 8.2Z"/>
       <path d="M8.6 8.2V6.4a3.4 3.4 0 0 1 6.8 0v1.8"/>
      </svg>
      <b>{cart.reduce((s,x)=>s+x.qty,0)}</b>
     </a>
    </div>
   </div>

   <nav className={`main-nav v724-main-nav${mega?' is-open':''}`} onMouseLeave={()=>setMega(null)} aria-label="ניווט ראשי">
    <div className="container nav-inner v724-nav-inner mp8-nav-inner">
     {navLink('חדשים באתר','/catalog?category=new','mp8-new-link')}
     {trigger('תכשיטים','rings')}
     {navLink(cms.pages.about?.title||'אודות','/about')}
     {navLink('SALE','/catalog?sale=1','sale-link')}
     {navLink('צור קשר','/contact')}
    </div>

    {mega==='rings'&&<>
      <div className="mielley-mega-a" aria-label="קטגוריות תכשיטי MIELLEY">
       <div className="mielley-mega-a-grid">

        <a className="mielley-mega-a-side" href="/catalog?category=rings" onClick={e=>{e.preventDefault();go('/catalog?category=rings')}} aria-label="טבעות מוסונייט">
         <img src="/assets/mp6-hero-left.png" alt="טבעות מוסונייט MIELLEY"/>
        </a>

        <a className="mielley-mega-a-item" href="/catalog?category=bracelets" onClick={e=>{e.preventDefault();go('/catalog?category=bracelets')}}>
         <span className="mma-icon" aria-hidden="true">○</span>
         <h3>צמידי<br/>מוסונייט</h3>
         <div className="mielley-mega-a-product"><img src="/assets/mp6-bracelets.png" alt="צמידי מוסונייט"/></div>
         <span className="mielley-mega-a-link">לצפייה בקולקציה ←</span>
        </a>

        <a className="mielley-mega-a-item" href="/catalog?category=rings" onClick={e=>{e.preventDefault();go('/catalog?category=rings')}}>
         <span className="mma-icon" aria-hidden="true">◇</span>
         <h3>טבעות<br/>מוסונייט</h3>
         <div className="mielley-mega-a-product"><img src="/assets/mp6-rings.png" alt="טבעות מוסונייט"/></div>
         <span className="mielley-mega-a-link">לצפייה בקולקציה ←</span>
        </a>

        <a className="mielley-mega-a-item" href="/catalog?category=earrings" onClick={e=>{e.preventDefault();go('/catalog?category=earrings')}}>
         <span className="mma-icon" aria-hidden="true">✦</span>
         <h3>עגילי<br/>מוסונייט</h3>
         <div className="mielley-mega-a-product"><img src="/assets/mp6-earrings.png" alt="עגילי מוסונייט"/></div>
         <span className="mielley-mega-a-link">לצפייה בקולקציה ←</span>
        </a>

        <a className="mielley-mega-a-item" href="/catalog?category=necklaces" onClick={e=>{e.preventDefault();go('/catalog?category=necklaces')}}>
         <span className="mma-icon" aria-hidden="true">◌</span>
         <h3>שרשראות<br/>מוסונייט</h3>
         <div className="mielley-mega-a-product"><img src="/assets/mp6-necklaces.png" alt="שרשראות מוסונייט"/></div>
         <span className="mielley-mega-a-link">לצפייה בקולקציה ←</span>
        </a>

        <a className="mielley-mega-a-side" href="/catalog?category=rings" onClick={e=>{e.preventDefault();go('/catalog?category=rings')}} aria-label="קולקציית טבעות מוסונייט">
         <img src="/assets/mp6-hero-right.png" alt="טבעת מוסונייט סוליטר MIELLEY"/>
        </a>

       </div>
      </div>
     </>}
   </nav>
  </header>

  {menu&&<>
   <div className="overlay" onClick={()=>setMenu(false)}/>
   <aside className="mobile-drawer v724-mobile-drawer mp8-mobile-drawer">
    <header>
  <img
    src="/assets/mielley-brand-logo.png"
    alt="MIELLEY — LOOK EXPENSIVE. THINK SMART."
  />
  <button onClick={()=>setMenu(false)}>×</button>
</header>
    <a href="/catalog?category=new" onClick={e=>{e.preventDefault();go('/catalog?category=new')}}>חדשים באתר<span>←</span></a>
    <span className="v724-mobile-label">תכשיטים</span>
    <a href="/catalog?category=rings" onClick={e=>{e.preventDefault();go('/catalog?category=rings')}}>טבעות מוסונייט<span>←</span></a>
    <a href="/catalog?category=earrings" onClick={e=>{e.preventDefault();go('/catalog?category=earrings')}}>עגילי מוסונייט<span>←</span></a>
    <a href="/catalog?category=necklaces" onClick={e=>{e.preventDefault();go('/catalog?category=necklaces')}}>שרשראות מוסונייט<span>←</span></a>
    <a href="/catalog?category=bracelets" onClick={e=>{e.preventDefault();go('/catalog?category=bracelets')}}>צמידי מוסונייט<span>←</span></a>
    <span className="v724-mobile-label second">MIELLEY</span>
    <a href="/about" onClick={e=>{e.preventDefault();go('/about')}}>אודות<span>←</span></a>
    <a href="/catalog?sale=1" onClick={e=>{e.preventDefault();go('/catalog?sale=1')}}>SALE<span>←</span></a>
    <a href="/contact" onClick={e=>{e.preventDefault();go('/contact')}}>צור קשר<span>←</span></a>
   </aside>
  </>}

  {search&&<>
   <div className="overlay" onClick={()=>setSearch(false)}/>
   <section className="search-panel">
    <button onClick={()=>setSearch(false)}>×</button>
    <span>SEARCH</span>
    <h2>איזה תכשיט תרצו למצוא?</h2>
    <form onSubmit={e=>{e.preventDefault();go(`/catalog?q=${encodeURIComponent(q)}`)}}>
     <input autoFocus value={q} onChange={e=>setQ(e.target.value)} placeholder="טבעת, עגילים, שרשרת, צמיד או סגנון"/>
     <button>חיפוש</button>
    </form>
   </section>
  </>}
 </>;
}
